import { useContext } from "react";
import { CredentialsContext } from "~riata/contexts/CredentialsContext";

const useCredentials = () => {
  return useContext(CredentialsContext);
};

export default useCredentials;
